<template>
  <div class="ua-stock-subs">
    <div>
      <gt-button
        :size="isMobile ? 'small' : 'medium'"
        style="width: 100%"
        type="primary"
        @click="onSubscribe"
      >
        {{ pdp.subscription.sale[pdp.product.productNo] ? '已设置发售提醒' : '新品发售时通知我' }}
      </gt-button>
    </div>

    <no-ssr>
      <template v-if="isMobile">
        <GtDrawer
          :visible.sync="visible"
          size="240px"
          append-to-body
          direction="btt"
          :destroy-on-close="false"
          custom-class="ua-stock-subs-dlg-mob"
        >
          <div style="padding: 30px 20px 32px 20px">
            <div class="ua-stock-subs-ctt-mob">
              <h5>订阅发售通知</h5>
              <p>
                您的手机号码：
                <span>{{ encryptMobilePhone }}</span>
                已成功订阅发售通知
                <br />
                商品发售时将第一时间通过短信通知您
              </p>
              <gt-button
                size="small"
                type="primary"
                style="width: 100%; margin-top: 14px"
                @click="visible = false"
              >
                确定
              </gt-button>
            </div>
          </div>
        </GtDrawer>
      </template>

      <template v-else>
        <el-dialog
          :visible.sync="visible"
          width="540px"
          top="15%"
          custom-class="ua-stock-subs-dlg-pc"
          append-to-body
        >
          <div style="padding: 64px 40px">
            <div class="ua-stock-subs-ctt-pc">
              <h5>订阅发售通知</h5>
              <p>
                您的手机号码：
                <span>{{ encryptMobilePhone }}</span>
                已成功订阅发售通知
                <br />
                商品发售时将第一时间通过短信通知您
              </p>
              <gt-button
                size="medium"
                type="primary"
                style="width: 100%; margin-top: 32px"
                @click="visible = false"
              >
                确定
              </gt-button>
            </div>
          </div>
        </el-dialog>
      </template>
    </no-ssr>
  </div>
</template>

<script>
// import { GtMessage } from '@speedshop/template';
import { PDP } from '../lib/mixins';
import { getUserInfo } from '../lib/utils';

export default {
  name: 'PdtSubscribe',
  mixins: [PDP],
  data() {
    return {
      mobilePhone: ''
    };
  },
  computed: {
    encryptMobilePhone() {
      const d = this.mobilePhone;

      if (!d) return '';

      return d.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2');
    }
  },
  methods: {
    onSubscribe() {
      if (this.pdp.subscription.sale[this.pdp.product.productNo]) return;

      this.pdp.subscribeSaling(() => {
        this.mobilePhone = getUserInfo().mobile;
        this.visible = true;
      });
    }
  }
};
</script>

<style lang="scss" layout="pc" description="网页端样式">
.ua-stock-subs {
  &-dlg-pc {
    .el-dialog__body {
      padding: 0px;
    }

    .el-dialog__header {
      padding: 0px;
    }

    .el-dialog__headerbtn .el-icon {
      font-size: 24px;
    }
  }

  &-ctt-pc {
    > h5 {
      color: var(--main-color-ua-dark-grey, #14141e);
      text-align: center;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 26px; /* 130% */
      text-transform: capitalize;
    }

    > p {
      color: var(--secondary-color-ua-cool-grey-04, #50505a);
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px; /* 137.5% */
      text-transform: capitalize;
      margin-top: 8px;
    }
  }
}
</style>

<style lang="scss" layout="mobile" description="移动端样式">
.ua-stock-subs {
  &-dlg-mob {
    .el-drawer__header {
      margin-bottom: 0px !important;
      padding: 0px 20px 0px 0px;
    }

    .el-drawer__close-btn {
      transform: translateY(10px);
    }
  }

  &-ctt-mob {
    > h5 {
      color: var(--main-color-ua-dark-grey, #14141e);
      text-align: center;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 26px; /* 130% */
    }

    > p {
      color: var(--secondary-color-ua-cool-grey-04, #50505a);
      text-align: center;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px; /* 137.5% */
      margin-top: 4px;
    }
  }
}
</style>
